import { StaticRoutes } from './model/routes';
import * as roles from 'core/model/roles';

const menu = [
	{
		name: 'settings',
		role: roles.ADMIN,
		children: [
			{
				name: 'content',
				icon: 'fa fa-sitemap',
				url: StaticRoutes.ContentEdit,
				domain: 'admin',
			},
			{
				name: 'message',
				icon: 'fa fa-file-text',
				url: StaticRoutes.MessageEdit,
				domain: 'admin',
			},
		],
		domain: 'admin',
	},
];

export default menu;
